import { render, staticRenderFns } from "./videoPreview.vue?vue&type=template&id=5dea2cdb&scoped=true&"
import script from "./videoPreview.vue?vue&type=script&lang=js&"
export * from "./videoPreview.vue?vue&type=script&lang=js&"
import style0 from "./videoPreview.vue?vue&type=style&index=0&id=5dea2cdb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dea2cdb",
  null
  
)

export default component.exports